import { NgModule } from '@angular/core';

import { PublicRoutingModule } from './public-routing.module';
import { LoginModule } from './login/login.module';
import { SharedModule } from '../shared/shared.module';
import { ConfirmAccountModule } from './confirm-account/confirm-account.module';
import { RecoveryModule } from './recovery/recovery.module';
import { PrescriberSignupComponent } from './prescriber-signup/prescriber-signup.component';
import { RecaptchaModule } from 'ng-recaptcha';

@NgModule({
	declarations: [PrescriberSignupComponent],
	imports: [
		SharedModule,
		PublicRoutingModule,
		LoginModule,
		ConfirmAccountModule,
		RecoveryModule,
		RecaptchaModule
	]
})
export class PublicModule {}
